<template>
  <div id="app">
    <NavMenu />
    <Breadcrumb
          v-if="!($route.meta.showNavMenu || $route.meta.showBread)"
          :style="{ marginTop: topnavHeight + 'px' }"
        ></Breadcrumb>
    <router-view/>
     <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import NavMenu from "@/components/NavMenu.vue";
import Footer from "@/components/Footer.vue";
import Breadcrumb from "@/components/breadcrumb.vue";
export default {
  components: {
    NavMenu,
    Footer,
    Breadcrumb,
  },
  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
